import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  striche: [],
  alleStriche: [],
  loading: false,
  loaded: false,
  loadedAlle: false,
  error: null
}

// getters
const getters = {
  alleStriche (state) {
    return state.striche
  },
  striche (state) {
    let striche = []
    state.striche.forEach(strich => {
      if (strich.status === '') {
        striche.push(strich)
      }
    })
    return striche
  },
  userStriche: (state) => (user) => {
    let striche = []
    state.striche.forEach(strich => {
      if (strich.bbrID === user) {
        striche.push(strich)
      }
    })
    return striche
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadStriche ({commit}) {
    commit('setLoading', true)
    console.log('Striche laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('striche').where('status', '==', '')
    .onSnapshot(snapshot => {
      const striche = []
      snapshot.forEach(doc => {
        striche.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedStriche', striche)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  loadAlleStriche ({commit}, datum) {
    commit('setLoading', true)
    console.log('Alle Striche laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('striche').where('date', '>=', datum.von).where('date', '<=', datum.bis)
    .get()
    .then(snapshot => {
      const striche = []
      snapshot.forEach(doc => {
        striche.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedAlleStriche', striche)
        commit('setLoading', false)
        commit('setLoadedAlle', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createStrich ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('striche').add(payload)
      .then(key => {
        payload.date.seconds = payload.date.getTime() / 1000
        // commit('createStrich', {
        //   ...payload,
        //   id: key.id
        // })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteStrichData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('striche').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteStrich', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateStrichData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('striche').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      if ((payload.status === '') || payload.status === undefined) {
        commit('updateStrich', payload)
      } else {
        commit('deleteStrich', payload.id)
      }
    })
    .catch(error => {
      console.log('error')
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedStriche (state, payload) {
    state.striche = payload
  },
  setLoadedAlleStriche (state, payload) {
    state.alleStriche = payload
  },
  createStrich (state, payload) {
    state.striche.push(payload)
  },
  updateStrich (state, payload) {
    const strich = state.striche.find(strich => {
      return strich.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        strich[key] = payload[key]
      }
    })
  },
  deleteStrich (state, payload) {
    let array = state.striche
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.striche = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setLoadedAlle (state, payload) {
    state.loadedAlle = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/striche_alt.js